var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cv-icon-button',_vm._g({class:[
    `cv-header-global-action`,
    `${_vm.carbonPrefix}--header__action`,
    { [`${_vm.carbonPrefix}--header__action--active`]: _vm.dataActive },
  ],attrs:{"type":"button","aria-haspopup":"true","aria-controls":_vm.ariaControls,"aria-expanded":_vm.active ? 'true' : 'false',"id":_vm.uid,"label":_vm.label,"tipAlignment":_vm.tipAlignment,"tipPosition":_vm.tipPosition},on:{"click":_vm.gaToggle,"focusout":_vm.gaFocusout}},_vm.$listeners),[_c('template',{slot:"icon"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }